/** Configuración del mega menú principal (claves i18n en navMega.*). */
import { orthoPagePath } from './orthoMenuPages';
import { buildOrthoMegaMenuLinks } from './orthoTreatmentItems';
import { MAXILLARY_TREATMENT_ITEMS } from './maxillaryTreatmentItems';
import { paths } from '../routes/paths';

function maxillaryMegaMenuLinks() {
  return MAXILLARY_TREATMENT_ITEMS.map(({ pageId }) => ({
    pageId,
    labelKey: `navMega.maxillaryOrtho.${pageId}`,
    descKey: `navMega.maxillaryOrtho.${pageId}Desc`,
    to: orthoPagePath(pageId),
  }));
}

export const NAV_MEGA_ITEMS = [
  {
    id: 'orthodontics',
    labelKey: 'navMega.orthodontics.label',
    singleColumn: false,
    layout: 'treatmentCards',
    columns: [
      {
        titleKey: 'navMega.orthodontics.colTreatments',
        items: buildOrthoMegaMenuLinks(),
      },
    ],
  },
  {
    id: 'maxillaryOrtho',
    labelKey: 'navMega.maxillaryOrtho.label',
    singleColumn: false,
    layout: 'treatmentCards',
    treatmentSource: 'maxillary',
    columns: [
      {
        titleKey: 'navMega.maxillaryOrtho.colTreatments',
        items: maxillaryMegaMenuLinks(),
      },
    ],
  },
  {
    id: 'drPaniura',
    labelKey: 'navMega.drPaniura.label',
    singleColumn: false,
    columnLayout: 'two',
    columns: [
      {
        titleKey: 'navMega.drPaniura.colAbout',
        items: [
          { labelKey: 'navMega.drPaniura.profile', descKey: 'navMega.drPaniura.profileDesc', to: orthoPagePath('drProfile') },
          { labelKey: 'navMega.drPaniura.approach', descKey: 'navMega.drPaniura.approachDesc', to: orthoPagePath('drApproach') },
          { labelKey: 'navMega.drPaniura.invisalign', descKey: 'navMega.drPaniura.invisalignDesc', to: orthoPagePath('drInvisalign') },
        ],
      },
      {
        titleKey: 'navMega.why.colReasons',
        items: [
          { labelKey: 'navMega.why.smileUp', descKey: 'navMega.why.smileUpDesc', to: orthoPagePath('whySmileUp') },
          { labelKey: 'navMega.why.international', descKey: 'navMega.why.internationalDesc', to: orthoPagePath('whyInternational') },
          { labelKey: 'navMega.why.comfort', descKey: 'navMega.why.comfortDesc', to: orthoPagePath('whyComfort') },
          { labelKey: 'navMega.why.evaluation', descKey: 'navMega.why.evaluationDesc', to: orthoPagePath('whyEvaluation') },
        ],
      },
    ],
  },
  {
    id: 'nextStep',
    labelKey: 'navMega.nextStep.label',
    singleColumn: true,
    columns: [
      {
        titleKey: 'navMega.nextStep.colAction',
        items: [
          { labelKey: 'navMega.nextStep.book', descKey: 'navMega.nextStep.bookDesc', to: orthoPagePath('bookConsult') },
          { labelKey: 'navMega.nextStep.firstAppt', descKey: 'navMega.nextStep.firstApptDesc', to: orthoPagePath('firstAppt') },
          { labelKey: 'navMega.nextStep.location', descKey: 'navMega.nextStep.locationDesc', to: orthoPagePath('location') },
        ],
      },
    ],
  },
  {
    id: 'resources',
    labelKey: 'navMega.resources.label',
    singleColumn: true,
    columns: [
      {
        titleKey: 'navMega.resources.colGuides',
        items: [
          { labelKey: 'navMega.resources.blog', descKey: 'navMega.resources.blogDesc', to: '/blog' },
          { labelKey: 'navMega.resources.emergency', descKey: 'navMega.resources.emergencyDesc', to: paths.emergency },
          { labelKey: 'navMega.resources.alignersGuide', descKey: 'navMega.resources.alignersGuideDesc', to: '/blog/orthodontics-cusco-braces-aligners' },
          { labelKey: 'navMega.resources.firstConsult', descKey: 'navMega.resources.firstConsultDesc', to: orthoPagePath('firstConsult') },
        ],
      },
    ],
  },
];
